import React from 'react';

const Location = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.99967 15C7.20069 15 3 11.4572 3 7.75228C3 4.85183 5.23807 2.5 7.99967 2.5C10.7613 2.5 13 4.85183 13 7.75228C13 11.4572 8.79866 15 7.99967 15Z"
        fill="#7E50FF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.66683 7.50038C9.66683 6.57953 8.92067 5.83337 8.0005 5.83337C7.07965 5.83337 6.3335 6.57953 6.3335 7.50038C6.3335 8.42055 7.07965 9.16671 8.0005 9.16671C8.92067 9.16671 9.66683 8.42055 9.66683 7.50038Z"
        fill="white"
      />
    </svg>
  );
};

export default Location;
